import moment from "moment";
import Vue from "vue";

const FlashMessagesStore = {
  state: {
    flashMessages: {}
  },

  mutations: {
    ADD_FLASH_MESSAGE(state, fm) {
      let id = moment().valueOf()
      fm.id = id
      Vue.set(state.flashMessages, id, fm)
    },
    REMOVE_FLASH_MESSAGE(state, fm) {
      state.flashMessages[fm.id] = null
    }
  },

  getters: {
    flashMessages: state => state.flashMessages
  },

  actions: {
    addFlashMessage({ commit }, fm) {
      // TODO : Write checks to make sure the message contains all necessary elements
      commit("ADD_FLASH_MESSAGE", fm);
    },
    removeFlashMessage({ commit }, fm) {
      commit("REMOVE_FLASH_MESSAGE", fm);
    }
  }
};

export default FlashMessagesStore;
